import React from 'react'
import { injectIntl } from 'react-intl'

import GridContainer from '@naturacosmeticos/natds-web/dist/Components/GridContainer'
import GridItem from '@naturacosmeticos/natds-web/dist/Components/GridItem'
import withStyles from '@material-ui/core/styles/withStyles'
import Hidden from '@material-ui/core/Hidden'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'

import Grid from '@material-ui/core/Grid'
import styles from './EarningsCalculator.styles'

import EarningsCalculatorCardDesktop from './EarningsCalculatorCardDesktop'
import EarningsCalculatorResults from './EarningsCalculatorResults'

import EarningsCalculatorCardMobile from './EarningsCalculatorCardMobile'
import useDataLayer from '../../hooks/useDataLayer'

const PureEarningsCalculator = ({
  classes,
  chartInfo,
  onlineChartInfo,
  chartLevels,
  intl,
  products,
  catalog,
  productsImage,
  isEloThemeActive,
  tabActive,
  setTabActive,
  langKey
}) => {

  const dataLayer = useDataLayer()

  const setDataLayer = (buttonId, buttonText) => () => {
    dataLayer.push({
      event: 'buttonClick',
      buttonId,
      buttonText
    })
  }

  const f2fSales = {
    id: 'f2f-sales-clickable',
    label: intl.formatMessage({ id: 'regularSalesButtonText' })
  }

  const onlineSales = {
    id: 'online-sales-clickable',
    label: intl.formatMessage({ id: 'onlineSalesButtonText' })
  }

  return (
    <>
      <Tabs
        value={tabActive}
        onChange={(e, index) => {
          setTabActive(index)
        }}
        indicatorColor="primary"
        textColor="primary"
        classes={{
          root: classes.customTabs,
          indicator: classes.customTabIndicator
        }}
        centered
      >
        <Tab
          id={f2fSales.id}
          data-gtm-category-ga4="landing_earnings"
          data-gtm-main-action-ga4="click"
          data-gtm-label-ga4={f2fSales.label}
          data-testid="earnings-calculator-facetoface-sales"
          label={f2fSales.label}
          classes={{ root: classes.customTab, selected: classes.tabActive }}
          onClick={setDataLayer(f2fSales.id, f2fSales.label)}
        />
        <Tab
          id={onlineSales.id}
          data-gtm-category-ga4="landing_earnings"
          data-gtm-main-action-ga4="click"
          data-gtm-label-ga4={onlineSales.label}
          data-testid="earnings-calculator-internet-sales"
          label={onlineSales.label}
          classes={{ root: classes.customTab, selected: classes.tabActive }}
          onClick={setDataLayer(onlineSales.id, onlineSales.label)}
        />
      </Tabs>
      <Hidden only="xs">
        <Grid justify="center" container className={classes.contentContainer}>
          <Grid className={classes.flexColumnLeft} item>
            <EarningsCalculatorCardDesktop
              isEloThemeActive={isEloThemeActive}
              tabActive={tabActive}
              productsImage={productsImage}
              products={products}
              catalog={catalog}
            />
          </Grid>
          <Grid className={classes.flexColumnRight} item>
            <EarningsCalculatorResults
              chartLevels={chartLevels}
              chartInfo={chartInfo}
              onlineChartInfo={onlineChartInfo}
              tabActive={tabActive}
              langKey={langKey}
            />
          </Grid>
        </Grid>
      </Hidden>
      <Hidden smUp>
        <GridContainer direction="column">
          <GridItem>
            <EarningsCalculatorCardMobile
              isEloThemeActive={isEloThemeActive}
              tabActive={tabActive}
              productsImage={productsImage}
              chartInfo={chartInfo}
              products={products}
              catalog={catalog}
            />
          </GridItem>
          <GridItem>
            <EarningsCalculatorResults
              chartLevels={chartLevels}
              chartInfo={chartInfo}
              onlineChartInfo={onlineChartInfo}
              tabActive={tabActive}
              langKey={langKey}
            />
          </GridItem>
        </GridContainer>
      </Hidden>
    </>
  )
}

const EarningsCalculator = withStyles(styles)(
  injectIntl(PureEarningsCalculator)
)

export default EarningsCalculator
